import React from 'react'
import type { LucideIcon as LucideIconType } from 'lucide-react'

interface LucideIconProps {
  icon: LucideIconType
  size?: number
  /**
   * Forwarded because antd clones elements passed via an `icon` prop (e.g. Menu items) and injects its own
   * spacing/state classes onto them; dropping it would break e.g. the icon-to-label gap in a Dropdown menu.
   */
  className?: string
}

const LucideIcon: React.FC<LucideIconProps> = ({ icon: IconComponent, size = 14, className }) => (
  <IconComponent size={size} className={className} style={{ verticalAlign: '-0.125em', lineHeight: 0, opacity: 0.9 }} />
)

export default LucideIcon
